import type { Session } from '@supabase/supabase-js';

/**
 * E2E-only stub session. Must never activate in production builds.
 * Playwright sets REACT_APP_E2E_STUB_AUTH=true for `npm start` (NODE_ENV=development).
 */
export function isE2eStubAuthEnabled(
  nodeEnv: string | undefined = process.env.NODE_ENV,
  flag: string | undefined = process.env.REACT_APP_E2E_STUB_AUTH,
): boolean {
  return nodeEnv !== 'production' && flag === 'true';
}

export function buildE2eStubSession(): Session {
  const now = Math.floor(Date.now() / 1000);
  return {
    access_token: 'e2e-stub-token',
    refresh_token: 'e2e-stub-refresh',
    expires_in: 3600,
    expires_at: now + 3600,
    token_type: 'bearer',
    user: {
      id: '1',
      aud: 'authenticated',
      role: 'authenticated',
      email: 'user@example.com',
      email_confirmed_at: new Date().toISOString(),
      phone: '',
      confirmed_at: new Date().toISOString(),
      last_sign_in_at: new Date().toISOString(),
      app_metadata: { provider: 'e2e', providers: ['e2e'] },
      user_metadata: { display_name: 'E2E User' },
      identities: [],
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      is_anonymous: false,
    },
  } as Session;
}
